/**
 * @owner @Appboy/operator
 */

import partition from "lodash/partition";
/*
 * Pusher pub/sub to get data from pusher downstream
 * to React without having to add more network listeners
 */
export default class PusherObserver {
  static MAX_UNHANDLED_MESSAGES: number = 100;

  static subscriptions: Record<string, (data: any) => void> = {};
  static unhandledMessages: Array<{ fnKey: string; data?: any }> = [];

  static on(key: string, fn: (data: any) => void): void {
    this.subscriptions[key] = fn;
  }

  static off(key: string): void {
    delete this.subscriptions[key];
  }

  static emit(fnKey: string, data?: any): void {
    if (this.subscriptions[fnKey]) {
      this.subscriptions[fnKey](data);
    } else {
      this.unhandledMessages.push({ fnKey, data });
      if (this.unhandledMessages.length > this.MAX_UNHANDLED_MESSAGES) {
        this.unhandledMessages.shift();
      }
    }
  }

  /* Emits the LAST RECEIVED, unhandled message for the given key. Additionally
   * it prunes any older messages with the same key from `unhandledMessages`.
   */
  static handleMissedMessage(fnKey: string): void {
    if (this.subscriptions[fnKey]) {
      const [inbox, unhandledMessages] = partition(this.unhandledMessages, { fnKey: fnKey });
      this.unhandledMessages = unhandledMessages;
      if (inbox.length > 0) {
        this.emit(fnKey, inbox[inbox.length - 1].data);
      }
    }
  }
}
